import CenteredContentLayout from "@/components/layout/CenteredContentLayout";
import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute } from "@tanstack/react-router";
import { i18n } from "@lingui/core";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import ReferralCopyButton from "./-components/ReferralCopyButton";
import ReferralEarnings from "./-components/ReferralEarnings";
import ReferralEarningsCard from "./-components/ReferralEarningsCard";
import ReferralImage from "./-components/ReferralImage";

export const Route = createFileRoute("/_main/referral/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleReferrals),
      },
    ],
  }),
  component: ReferralPage,
});

function ReferralPage() {
  return (
    <PageLayout>
      <CenteredContentLayout>
        <div className="flex h-full w-full flex-col gap-1.5">
          <div className="flex h-full w-full flex-col gap-1.5 overflow-y-auto xl:flex-row xl:overflow-hidden">
            <div className="flex w-full flex-col gap-1.5 xl:w-[40%] 2xl:w-[642px]">
              <div className="bg-card min-h-[390px] w-full overflow-hidden rounded-3xl p-4 sm:p-4 md:p-5 xl:h-[calc(100%-300px)]">
                <div className="relative flex h-full items-center justify-center">
                  <div className="absolute inset-0 bg-[radial-gradient(#2A2A3B75_1.5px,transparent_1px)] [background-size:16px_16px]" />
                  <div className="relative z-20 h-full w-full">
                    <ReferralImage />
                  </div>
                </div>
              </div>
              <ReferralEarningsCard />
            </div>
            <div className="bg-card flex h-full flex-1 flex-col gap-5 rounded-3xl p-5">
              <ReferralCopyButton />
              <ReferralEarnings />
            </div>
          </div>
        </div>
      </CenteredContentLayout>
    </PageLayout>
  );
}
